import { Period } from '@api';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './PriceMovementLegend.module.scss';

export interface PriceMovementLegendProps {
  bestHorizon?: Period;
  legendLabel?: string;
  isShowCumulativeReturn: boolean;
}

export const PriceMovementLegend = ({
  bestHorizon,
  legendLabel,
  isShowCumulativeReturn,
}: PriceMovementLegendProps) => {
  const { t } = useTranslation('widget');
  return (
    <div className={styles.legend} data-testid="price-movement-horizon" data-legend>
      {bestHorizon && (
        <div className={styles.legendItem} data-testid="legend-best-horizon">
          <div className={styles.iconPrimary} />
          <span className={styles.legendLabel} data-legend-label>
            {t('widget:priceMovement.chartLegend.bestHorizon')}
          </span>
        </div>
      )}
      <div className={styles.legendItem}>
        <div className={styles.iconBar} />
        <span className={styles.legendLabel} data-legend-label>
          {t('widget:priceMovement.chartLegend.tradingRange')}
        </span>
      </div>
      <div className={styles.legendItem}>
        <div className={styles.iconMedian} />
        <span className={styles.legendLabel} data-legend-label>
          {legendLabel ?? t('widget:priceMovement.chartLegend.median')}
        </span>
      </div>
      {isShowCumulativeReturn && (
        <div className={styles.legendItem}>
          <div className={styles.iconCumulativeReturn} />
          <span className={styles.legendLabel} data-legend-label>
            {t('widget:priceMovement.chartLegend.cumulativeReturn')}
          </span>
        </div>
      )}
    </div>
  );
};
